import { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAppDispatch } from "@/store/hooks";
import { getStatusList } from '@/store/slices/customerSlice';
import { useSelector } from "react-redux";
import type { RootState } from "@/store/rootReducer";
import Modal from "@/components/Modal/Modal";
import toast from "@/lib/toast";

interface StatusModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (value: any) => void;
}

export default function StatusModal({ open, onClose, onSelect }: StatusModalProps) {
  const dispatch = useAppDispatch();
  const { statusList } = useSelector((state: RootState) => state.customer);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(true);

      dispatch(getStatusList())
        .unwrap()
        .catch((err) => {
          toast.error(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [open, dispatch]);

  return (
    <Modal
      heading="Status List"
      modalOpen={open}
      hideAddButton={true}
      closeModal={onClose}
      width="250px"
    >
      <Box sx={{ bgcolor: "#fff", minHeight: "100px" }}>
        {loading && (
          <Box className="flex justify-center items-center h-[100px]">
            <CircularProgress size={24} />
          </Box>
        )}

        {!loading && (!statusList || statusList.length === 0) && (
          <Typography align="center" sx={{ py: 2 }}>
            No status found
          </Typography>
        )}

        {!loading && statusList?.map((item: any) => (
          <Typography
            key={item.StatusId}
            onClick={() => onSelect({ id: item.StatusId, name: item.Status })}
            sx={{
              py: 1,
              cursor: "pointer",
              fontSize: 15,
              "&:hover": { bgcolor: "#f5f5f5" },
            }}
          >
            {item.Status}
          </Typography>
        ))}
      </Box>
    </Modal>
  );
}
